import React from 'react'
import EasebuzzSubmerchantTable from 'containers/Staff/EasebuzzSubmerchantTable'

const EasebuzzSubmerchant: React.FC = () => {
    return (
        <div>
            <EasebuzzSubmerchantTable />
        </div>
    )
}

export default EasebuzzSubmerchant
